import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import axios from "../axios";
import qs from 'qs';
import Alert from "react-s-alert";
import FormDropdown from './FormDropdown'
import { status_aktif } from '../constants/general'

const tingkat_kelas = []

for (let i=0; i<=11; i++) {
    tingkat_kelas[i] = {
        key     : i + 1,
        value   : i + 1
    }
}

class FormModalKelas extends Component {

    constructor(props) {
        super(props);

        this.state = {

            kelas_id        : "",
            kelas_nama      : "",
            kelas_level     : "",
            kelas_status    : "",
            isButtonLoading : false,
            isLoading       : false,
            dataShift       : [],
            
            isLoadingBu : false
        }

        this.toggleModalKelas = this.toggleModalKelas.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    toggleModalKelas() {
        this.props.toggleModalKelas()
    }

    handleSubmit() {

        this.setState({ isLoadingBu: true })

        axios({
            method: 'post',
            url: '/kelas/add',
            data: qs.stringify(this.state)
        })
            .then(response => {
                const result = response.data;
                
                if (result.success){
                    Alert.success(result.message);
                    this.setState({wali_id:result.data, isLoadingBu: false,user_passw : '' }, ()=>{
                        window.location.reload();
                    });
                    this.toggleModalKelas();
                }else{
                    Alert.success(result.message);
                    this.setState({ isLoadingBu: false,user_passw : '' }, ()=>{
                        window.location.reload();
                    });
                    this.toggleModalKelas();
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({ isLoadingBu: false,user_passw : '' })
                Alert.error("Gagal terhubung ke server!")
            })
    }
    
    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    loadShift() {
        this.setState({ isLoading: true });
        axios({
            method: "post",
            url: "/shift"
        })
        .then(response => {
            const result = response.data;
            if (result.success === true) {
                const dataShift = result.data.map(item => ({
                    key: item.id,
                    value: item.name+' ('+item.start+'-'+item.end+')'
                }));

                this.setState({
                    dataShift,
                    isLoading: false
                });
            } else {
                Alert.error(result.message);
                this.setState({ isLoading: false });
            }
        })
        .catch(error => {
            console.log(error);
            this.setState({ isLoading: false });
            Alert.error("Gagal terhubung ke server!");
        });
    }

    componentDidMount() {
        this.loadShift()
    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.toggleModalKelas} className="modal-primary custom-dialog">
                <ModalHeader toggle={this.toggleModalKelas}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    
                        <div className="form-horizontal animated fadeIn">
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Nama Kelas</label>
                                    <div className="col-md-10">
                                        <input 
                                            name="kelas_nama"
                                            type="text"
                                            className="form-control"
                                            placeholder="Nama Kelas. Contoh: X IPA A, IX IPS B, dst" 
                                            onChange={this.handleChange} 
                                            value={this.state.kelas_nama} />
                                    </div>
                                </div>   
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Tingkat Kelas</label>
                                    <div className="col-md-10">
                                        <FormDropdown
                                            items={tingkat_kelas}
                                            onChange={this.handleChange}
                                            value={this.state.kelas_level}
                                              name="kelas_level"
                                          />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Jam Masuk</label>
                                    <div className="col-md-10">
                                        <FormDropdown
                                            items={this.state.dataShift}
                                            onChange={this.handleChange}
                                            value={this.state.shift_id}
                                              name="shift_id"
                                          />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Status Aktif</label>
                                    <div className="col-md-10">
                                        <FormDropdown
                                            items={status_aktif}
                                            onChange={this.handleChange}
                                            value={this.state.kelas_status}
                                            name="kelas_status"
                                        />
                                    </div>
                                </div>
                            </div>     

                </ModalBody>
                <ModalFooter>
                    <button 
						type="button" 
						className="btn btn-md btn-primary"
						disabled={this.state.isButtonLoading && "disabled"}
						onClick={this.handleSubmit}>
                            
							{this.state.isButtonLoading ? "Loading" : "Simpan"}
					</button>{' '}
                    <Button color="secondary" onClick={this.toggleModalKelas}>Batal</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

FormModalKelas.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    toggleModalKelas: PropTypes.func.isRequired
}

export default FormModalKelas


// WEBPACK FOOTER //
// ./src/components/FormModalKelas.js